module.exports = __webpack_public_path__ + "static/img/wealth_level_85.c1fd70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_85.png
// module id = p3Ar
// module chunks = 0